import declare from "dojo/_base/declare";
import NewFoodSKUDataSheetsController from "./NewFoodSKUDataSheetsController";
import NewTestRun from "src/Quality/NewTestRun";

const NewFoodSKUTestRunController = declare([NewFoodSKUDataSheetsController, NewTestRun], {

	relationshipId: "SKUTestRuns",

});

export = NewFoodSKUTestRunController;